export default __webpack_public_path__ + "static/media/bangalore.c73f26ed.webp";